define(()=> {
    return ['$q', 'JsonRPCService', 'qnb.endpointConfig', ($q, JsonRPCService, endpointConfig)=> {
        const endpoint = endpointConfig.loadSaveEndpoint;
        return {
            updateReferrer: (callGroups, referrerDTO)=> {
                const deferred = $q.defer();
                JsonRPCService.send('quote', endpoint, 'updateReferrerInformation', [referrerDTO], callGroups, true).then(
                    ()=> { return deferred.resolve(); },
                    (error, status, headers)=> deferred.reject([error, status, headers]));
                return deferred.promise;
            },
        };
    }];
});


// WEBPACK FOOTER //
// ../common/js/src/edge/quoteandbind/baslercommon/services/BaslerReferrerService.js